import React, { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import '../FriendAndFamily/MyStyles/style.css';
import '../FriendAndFamily/MyStyles/responsive.css';
//import ErrorPage from '../ErrorPage';
import ErrorIcon from '@mui/icons-material/Error';
import Loader from '../Utilities/Loader'

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const PaymentStatus = () => {

    const [searchParams] = useSearchParams();
    const queryValue = searchParams.get('SessionID');

    const [paymentDetails, setPaymentDetails] = useState(null);
    const [failedStatusCount, setFailedStatusCount] = useState(0);
    const [paymentStatus, setPaymentStatus] = useState("Pending");
    const [firstLoad, setFirstLoad] = useState(true);
    //const [paymentDate, setPaymentDate] = useState("");


    const getPaymentStatus = () => {
        const req = {
            OrderID: queryValue
        }

        fetch(`${apiBaseURL}/api/FriendAndFamily/PaymentAcknowledgmentForWatcho`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(req)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(resultInfo => {
                //console.log("API Response6:", resultInfo);
                //setLoading(false);
                setFirstLoad(false);
                if (resultInfo && resultInfo.resultStatus === "Success") {
                    setPaymentDetails(resultInfo.result);
                    setPaymentStatus("Success");

                    //const dateString = resultInfo.result.paymentDate;
                    //const date = new Date(dateString);

                    //const formattedDate = new Intl.DateTimeFormat('en-GB', {
                    //    day: '2-digit',
                    //    month: 'short',
                    //    year: 'numeric',
                    //}).format(date);
                    //setPaymentDate(formattedDate);

                    //setTimeout(() => {
                    //    goToHomepage();
                    //}, 30000)
                }
                else if (resultInfo && resultInfo.resultStatus === "Failed") {
                    setFailedStatusCount((prv) => prv + 1);
                    setPaymentStatus("Failed");
                    //if (failedStatusCount <= 6) { 
                    //    setTimeout(() => {
                    //        getPaymentStatus(searchParams)
                    //    }, 10000) 
                    //}
                    //setTimeout(() => {
                    //    goToHomepage();
                    //}, 90000)
                }
                else if (resultInfo && resultInfo.resultStatus === "Pending") {
                    setFailedStatusCount((prv) => prv + 1);
                    setPaymentStatus("Pending");
                    //if (failedStatusCount <= 6) { 
                    //    setTimeout(() => {
                    //        getPaymentStatus(searchParams)
                    //    }, 10000) 
                    //}
                    //setTimeout(() => {
                    //    goToHomepage();
                    //}, 90000)
                }
            })
            .catch(err => {
                console.error("Error calling GenerateBulkSubscriptionRequest API:", err);

            });
    }


    useEffect(() => {

        if (firstLoad) {
            getPaymentStatus(searchParams)
        }
        if ((paymentStatus === "failed" || paymentStatus === "pending") && failedStatusCount <= 6) {
            setTimeout(() => {
                getPaymentStatus(searchParams)
            }, 10000)
        }

    }, [failedStatusCount]);

    return (<>
        {firstLoad ? /*<div >loading....</div>*/
            <Loader showLoading={firstLoad} />
            : <div className="containerThankuMain">
                {paymentStatus === "Success" && <>
                        <div>
                            <nav className="navbar navbar-expand-lg custom-navbar navbar-FF">
                                <div className="container-fluid mobile-res-clss">
                                    <a className="navbar-brand custom-logo" href="https://www.watcho.com/">
                                        <img src="/Images/logo.svg" alt="MyLogo" className="img-fluid clas-of-logo" />
                                    </a>
                                </div>
                            </nav>

                            <div className="container my-5">
                                <div className="text-center">
                                    <div className="congrats-container-fornew">
                                        <div className="check-icon">
                                            <img src="/Images/Group 39.png" alt="success" />
                                        </div>
                                        <h2>Congratulations!</h2>
                                        <h3>Your payment was successful!</h3>
                                        <p className="text-muted-corporate-voucher">Thank you for your payment. We will be in contact with more details shortly.</p>
                                        {/*<div className="details-box-detail mx-auto">*/}
                                            {/*<div className="detail-item-office">*/}
                                            {/*    <span className="detail-label-new">Order ID</span>*/}
                                            {/*    <span className="detail-value">{paymentDetails.orderID}</span>*/}
                                            {/*</div>*/}
                                            {/*<div className="detail-item-office">*/}
                                            {/*    <span className="detail-label-new">Amount paid</span>*/}
                                            {/*    <span className="detail-value">₹{paymentDetails.amount}</span>*/}
                                            {/*</div>*/}
                                            {/*<div className="detail-item-office">*/}
                                            {/*    <span className="detail-label-new">Payment Date</span>*/}
                                            {/*    <span className="detail-value">{paymentDate}</span>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}

                                    </div>
                                </div>
                            </div>
                        </div>
                </>
                }
                {paymentStatus === "Failed" &&
                    <div>
                        <nav className="navbar navbar-expand-lg custom-navbar navbar-FF">
                            <div className="container-fluid mobile-res-clss">
                                <a className="navbar-brand custom-logo" href="https://www.watcho.com/">
                                    <img src="/Images/logo.svg" alt="My Logo" className="img-fluid clas-of-logo" />
                                </a>
                            </div>
                        </nav>
                        <div className="container my-5">
                            <div className="text-center">
                                <div className="congrats-container-img">
                                    <div className="check-icon-img">
                                        <img src="/Images/error.png" alt="error" />
                                    </div>
                                    <h2>Oops! Payment Failed</h2>
                                    <h3>We are unable to process your payment</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {paymentStatus === "Pending" &&
                    <div>
                        <nav className="navbar navbar-expand-lg custom-navbar navbar-FF">
                            <div className="container-fluid mobile-res-clss">
                                <a className="navbar-brand custom-logo" href="https://www.watcho.com/">
                                    <img src="/Images/logo.svg" alt="My Logo" className="img-fluid clas-of-logo" />
                                </a>
                            </div>
                        </nav>
                        <div className="container my-5">
                            <div className="text-center">
                                <div className="congrats-container-pending">
                                    <div className="check-icon-img">
                                        <ErrorIcon sx={{ color: "#f5ae00", fontSize: "100px", backgroundColor: "#fff", borderRadius:"50px"  }} />
                                    </div>
                                    <h2>Payment Pending</h2>
                                    <h3>Your payment is pending. Please wait while we get status of your payment.</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    </>
    );
}